class TTSManager {
  constructor() {
    this.utterance = null
    this.currentCallback = null
    this.isPaused = false
    this.synthesis = window.speechSynthesis
  }

  /**
   * 朗读文本
   * @param {string} text - 要朗读的内容
   * @param {Function} callback - 朗读结束时的回调（成功或失败均触发）
   * @param {Object} options - 可选参数 { rate, pitch, volume, lang, voice }
   */
  speak(text, callback, options = {}) {
    if (!text || typeof text !== 'string') {
      if (callback) callback(new Error('Invalid text'))
      return
    }

    // 先取消当前正在播放的语音
    this.cancel()

    // 创建新的 utterance
    const utterance = new SpeechSynthesisUtterance(text)
    this.utterance = utterance
    this.currentCallback = callback
    this.isPaused = false

    // 设置参数
    utterance.rate = options.rate || 1.0        // 语速 0.1~10
    utterance.pitch = options.pitch || 1.0      // 音调 0~2
    utterance.volume = options.volume || 1.0    // 音量 0~1
    if (options.lang) utterance.lang = options.lang
    if (options.voice) utterance.voice = options.voice

    // 绑定事件
    utterance.onend = () => {
      this.utterance = null
      if (this.currentCallback) {
        this.currentCallback(null) // 成功结束
        this.currentCallback = null
      }
      this.isPaused = false
    }

    utterance.onerror = (event) => {
      this.utterance = null
      if (this.currentCallback) {
        this.currentCallback(new Error(event.error || 'Speech synthesis error'))
        this.currentCallback = null
      }
      this.isPaused = false
    }

    // 开始朗读
    this.synthesis.speak(utterance)
  }

  /**
   * 暂停朗读
   */
  pause() {
    if (this.synthesis.speaking && !this.synthesis.paused) {
      this.synthesis.pause()
      this.isPaused = true
    }
  }

  /**
   * 恢复朗读
   */
  resume() {
    if (this.synthesis.speaking && this.synthesis.paused) {
      this.synthesis.resume()
      this.isPaused = false
    }
  }

  /**
   * 取消朗读（停止并清空队列）
   */
  cancel() {
    this.synthesis.cancel()
    this.utterance = null
    if (this.currentCallback) {
      // 如果正在朗读中被取消，视为未完成，回调错误
      this.currentCallback(new Error('Cancelled'))
      this.currentCallback = null
    }
    this.isPaused = false
  }

  /**
   * 是否正在朗读（包括暂停状态）
   */
  isSpeaking() {
    return this.synthesis.speaking
  }

  /**
   * 是否处于暂停状态
   */
  get paused() {
    return this.isPaused
  }
}

// 导出单例
export default new TTSManager()